/** 这里放全局app的状态  尽量不涉及其他模块 尽量统一local的操作 存取都统一 可以全部放到vuex里 也可以新建工具类封装  */

import local from "@/utils/local";
import { isEmpty } from "@/utils";

const state = {
    indexPopState: !isEmpty(local.get("indexPopState")) ?
        local.get("indexPopState") : 0 //0 未弹窗， 1-已经弹窗了  首页广告弹窗，这里有逻辑 未登录每次弹窗  已登录只弹框一次
};

const mutations = {
    SET_INDEX_POP_STATE: (state, indexPopState) => {
        state.indexPopState = indexPopState;
        local.set("indexPopState", indexPopState);
    }
};

const actions = {
    setIndexPopState({ commit }, state) {
        commit("SET_INDEX_POP_STATE", state);
        local.set("indexPopState", state);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};


// WEBPACK FOOTER //
// ./src/vuex/modules/app.js